import { TSignupSteps } from 'types';
import { getQueryParamValue } from 'utils/common/common';

type TDefaultParams = {
  __impersonate?: string | null;
  trailingSlash?: boolean;
};

const appendImpersonation = (
  path: string,
  impersonateParam?: string | null,
): string => {
  if (impersonateParam !== null) {
    if (!impersonateParam) {
      impersonateParam = getQueryParamValue('__impersonate');
    }

    if (impersonateParam && impersonateParam !== '0') {
      return `${path}${
        path.includes('?') ? '&' : '?'
      }__impersonate=${impersonateParam}`;
    }
  }

  return path;
};

export const APPLICATION_DOCUMENTS_PATH = '/application/documents';
export const NEW_APPLICATIONS_PATH = '/application/new';

export const PATH_NAMES = {
  home: (params?: TDefaultParams) =>
    appendImpersonation('/', params?.__impersonate),

  products: (params?: TDefaultParams) =>
    appendImpersonation('/products', params?.__impersonate),

  calculator: (params?: TDefaultParams) =>
    appendImpersonation('/calculator', params?.__impersonate),

  faqs: (params?: TDefaultParams) =>
    appendImpersonation('/faqs', params?.__impersonate),

  register: (params?: TDefaultParams) =>
    appendImpersonation('/register', params?.__impersonate),

  notFound: (params?: TDefaultParams) =>
    appendImpersonation('/404', params?.__impersonate),

  forbidden: (params?: TDefaultParams) =>
    appendImpersonation('/403', params?.__impersonate),

  whatsNew: (params?: TDefaultParams) =>
    appendImpersonation('/whats-new', params?.__impersonate),

  application: ({
    applicationId,
    trailingSlash = true,
    __impersonate,
  }: TDefaultParams & { applicationId?: string }) =>
    appendImpersonation(
      `/application${trailingSlash ? '/' : ''}?applicationId=${applicationId}`,
      __impersonate,
    ),

  applicationDocuments: ({
    applicationId,
    trailingSlash = true,
    __impersonate,
  }: TDefaultParams & { applicationId?: string }) =>
    appendImpersonation(
      `${APPLICATION_DOCUMENTS_PATH}${
        trailingSlash ? '/' : ''
      }?applicationId=${applicationId}`,
      __impersonate,
    ),

  newApplication: ({
    step,
    stateKey,
    trailingSlash,
    __impersonate,
  }: TDefaultParams & { step: TSignupSteps; stateKey?: string }) =>
    appendImpersonation(
      `/application/${step}${trailingSlash ? '/' : ''}?state_key=${stateKey}`,
      __impersonate,
    ),

  newApplicationStep0: (params?: TDefaultParams) =>
    appendImpersonation(NEW_APPLICATIONS_PATH, params?.__impersonate),

  newApplicationStep1: ({
    stateKey,
    trailingSlash = true,
    __impersonate,
  }: TDefaultParams & { stateKey?: string }) =>
    appendImpersonation(
      `${NEW_APPLICATIONS_PATH}${
        trailingSlash ? '/' : ''
      }?state_key=${stateKey}`,
      __impersonate,
    ),

  newApplicationProductOffers: ({
    stateKey,
    trailingSlash = true,
    __impersonate,
  }: TDefaultParams & { stateKey?: string }) =>
    appendImpersonation(
      `${NEW_APPLICATIONS_PATH}/productOffers${
        trailingSlash ? '/' : ''
      }?state_key=${stateKey}`,
      __impersonate,
    ),

  newApplicationDocuments: ({
    stateKey,
    trailingSlash = true,
    __impersonate,
  }: TDefaultParams & { stateKey?: string }) =>
    appendImpersonation(
      `${NEW_APPLICATIONS_PATH}/documents${
        trailingSlash ? '/' : ''
      }?state_key=${stateKey}`,
      __impersonate,
    ),
};
